const reducer = () => [''];

export default reducer;
